.mainElements {
	flex-direction: column;

	gap: 2rem;
	align-items: center;

	display: flex;
	width: fit-content;
	min-height: 80vh;
}

.addPublicationInvis {
	display: none !important;
}

.addPublication {
	margin: 0;
	width: 34rem;
}

.additionalElements {
	height: -moz-fit-content;
	height: fit-content;
	background-color: var(--depth1);
	border-radius: var(--roundedBig);
	flex-direction: column;
	width: fit-content;
	display: flex;
}

.additionalElements > * {
	position: sticky;
	top: 2rem;
}

.additionalElements > div {
	box-shadow: none;
	border-radius: var(--roundedBig);
}

.additionalElements > div > * {
	border-radius: var(--roundedBig);
	background-color: var(--depth1);
}

.multiSelectLabel {
	width: 350px;
	padding-left: 0.5rem;
	padding-right: 0.5rem; /* margin-right: 5px; */
	font-weight: bold;
}

.multiSelect > div,
.multiSelect ul {
	background-color: var(--depth2);
}

@media screen and (max-width: 1400px) {
	.additionalElements {
		display: none;
	}

	.filters > div {
		flex-wrap: wrap !important;
		justify-content: flex-start !important;
	}

	.filters > div > div {
		width: 50% !important;
	}
}

@media screen and (max-width: 1000px) {
	.publication {
		width: 34rem !important;
	}
}

@media screen and (max-width: 610px) {
	.publication {
		width: 100% !important;
	}
	.addPublication {
		width: 100% !important;
	}
	.filters > div {
		max-width: 90%;
		justify-content: center !important;
	}
	.filters > div > div {
		width: 100% !important;
	}
	.mainElements {
		justify-content: center;
	}
}
